var map = {
	"./1.svg": "90c1",
	"./checkmark-s.svg": "15d2",
	"./checkmark.svg": "f2fa",
	"./cuba.svg": "651c",
	"./fr.svg": "0715",
	"./icon-cart.svg": "d965",
	"./icon-close.svg": "3c76",
	"./icon-delete.svg": "11ca",
	"./icon-menu.svg": "716d",
	"./icon-minus.svg": "b398",
	"./icon-next.svg": "69c6",
	"./icon-plus.svg": "77ea",
	"./icon-previous.svg": "90cb",
	"./image-avatar.png": "b10a",
	"./italy.svg": "4873",
	"./jp.svg": "a3c1",
	"./logo.jpg": "17be",
	"./logo.svg": "e347",
	"./product/4902720092081_1.jpg": "2b92",
	"./product/4902720092081_2.jpg": "1d77",
	"./product/4902720092085_1.png": "cf44",
	"./product/4902720092085_2.png": "3923",
	"./product/Cigar.jpg": "9801",
	"./product/Cigar2.jpg": "343c",
	"./product/chivas-21-nam-royal-salute-190.jpg": "1c42",
	"./product/chivas-21-nam-royal-salute-_2.jpg": "5fc2",
	"./product/ruou-chivas-12-750-ml-2.jpg": "af14",
	"./product/ruou-chivas-12-750-ml.jpg": "0418",
	"./product/ruou_vang_1.jpg": "c4df",
	"./product/ruou_vang_2.jpg": "22a9",
	"./product/sua-morinaga-2-chilmil-3.jpg": "1c07",
	"./product/taoambro.jpg": "b5eb",
	"./product/taoambro2.jpeg": "d275",
	"./product/taoambro3.jpeg": "399a",
	"./product/thanhlong1.jpg": "3138",
	"./product/thanhlong2.jpeg": "6d05",
	"./product/thanhlong3.jpg": "c1e0",
	"./product/vien-uong-hapanix-1.jpg": "41f5",
	"./product/vien-uong-hapanix-2.jpg": "a2eb",
	"./qrcode.png": "a76d",
	"./qrcode.svg": "df28",
	"./rfid-icon.svg": "ccc0",
	"./scotland.svg": "5250",
	"./sua-morinaga-2.jpg": "8e74",
	"./sua-morinaga.jpg": "55d1",
	"./us.svg": "274c",
	"./vn.svg": "73b6",
	"./warning-s.svg": "6a6a",
	"./warning.svg": "e4db"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";